import alignmentStyles from './../../shared/stylesheets/alignment/index.css'

const getClasses = (param, prefix) => {
  switch (param) {
    case 'top':
      return alignmentStyles[`${prefix ? prefix + '-' : ''}align-top`]
    case 'bottom':
      return alignmentStyles[`${prefix ? prefix + '-' : ''}align-bottom`]
    case 'middle':
      return alignmentStyles[`${prefix ? prefix + '-' : ''}align-middle`]
    case 'left':
      return alignmentStyles[`${prefix ? prefix + '-' : ''}align-left`]
    case 'right':
      return alignmentStyles[`${prefix ? prefix + '-' : ''}align-right`]
    case 'center':
      return alignmentStyles[`${prefix ? prefix + '-' : ''}align-center`]
    default:
      return ''
  }
}

export const getPositionClasses = (desktopString = 'middle center', mobileString) => {
  
  const desktopStringArray = desktopString.split(' ')
  const desktopXAxis = getClasses(desktopStringArray[0])
  const desktopYAxis = getClasses(desktopStringArray[1])

  const desktopClasses = `${desktopXAxis} ${desktopYAxis}`
  if (!mobileString) {
    return desktopClasses
  }
  const mobileStringArray = mobileString.split(' ')
  const mobileXAxis = getClasses(mobileStringArray[0], 'mobile')
  const mobileYAxis = getClasses(mobileStringArray[1], 'mobile')
  const mobileClasses = `${mobileXAxis} ${mobileYAxis}`

  return `${desktopClasses} ${mobileClasses}`
}



// WEBPACK FOOTER //
// ./src/client/utils/alignment-classes.js